<template>
    <div class="lang">
        <div class="greeting">
            <div class="greeting__inner">
                <div class="greeting__bg"><img src="/resource/img/about-bg02.png" alt=""></div>
                <div class="greeting__tit pc-none">
                    <div class="greeting__tit-inner item1">
                        <div>
                            您好? 谢谢您访问wellness健康增进中心网站.
                        </div>
                    </div>
                </div>
                <div class="greeting__img">
                    <div class="greeting__img-inner">
                        <img src="/resource/img/img_hos01_01.jpg" alt="">
                    </div>
                    <div class="greeting__img-bg"></div>
                </div>
                <div class="greeting__text">
                    <div class="greeting__tit mo-none">
                        <div class="greeting__tit-inner item1">
                            <div>
                                您好? 谢谢您访问wellness健康增进中心网站.
                            </div>
                        </div>
                    </div>
                    <div class="desc">
                        <p>
                            自开院以来, 梨大木洞医院的梨大女性健康中心/健康增进中心以快速便捷的体检系统和必要时可立即就诊的一站式服务来构建了女性亲近舒适的诊疗环境, 作为健康管理伙伴一直备受大家喜爱.
                        </p>
    
                        <p>
                            另外, 2019年梨大首尔医院开院起梨大首尔医院wellness健康增进中心以"安乐(well-being)"及"健康(fitness)"为目标实现了守护大家幸福健康生活的同伴者.
                        </p>
    
                        <p>
                            2020年4月1日起梨花医疗院健康体检中心将扩大综合运营为梨大首尔医院wellness健康增进中心.
                        </p>
    
                        <p>
                            至此, 梨花医疗院不仅拥有更加准确的诊断, 精密的医疗设备和迅速舒适的诊疗环境, 还通过格调很高的便利设施来提供了最佳的健康体检服务. <br>
                            梨花医疗院独有的女性亲近性的诊疗环境上所需要细心护理的健康管理方面具有特殊性, 这不仅女性,对男性以及需要先进韩国医疗的全世界人, 都将提供与以往不同的健康管理系统.
                        </p>
                        <p>
                            为了让大家健康过幸福的生活梨大首尔医院wellness健康增进中心将一直陪在您身边.
                        </p>
    
    
                        <div class="name">
                            <p>梨花女子大学首尔医学中心健康促进中心</p>
                            <span>中心主任Hye Kyung Song</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { gsap, Power1 } from "gsap";
    import { ScrollTrigger } from "gsap/ScrollTrigger";
    gsap.registerPlugin(ScrollTrigger); // 추가된 부분
    export default {
        methods: {
            gsapAbout() {
                gsap.from(".greeting__img img", {
                    height: 0,
                    duration: 1,
                    delay: .5,
                });
                gsap.from(".greeting__img img", {
                    scale: 1.2,
                    duration: 4,
                    delay: 1.4,
                });
                gsap.from(".greeting__img-bg", {
                    opacity: 0,
                    x: 0,
                    y: 0,
                    duration: 1,
                    delay: 1.5,
                });
                gsap.from(".greeting__tit .item2 em span", {
                    width: 0,
                    duration: 1.5,
                    delay: 2,
                    ease: Power1.easeInOut,
                    // onComplete: () => {
                    //     gsap.to(".greeting__tit .item2 em span", {
                    //         backgroundColor: 'var(--aorta-P10)',
                    //         duration: 1.5
                    //     });
                    // }
                });
                gsap.from(".item1 div", {
                    y: '100%',
                    duration: .8,
                    delay: 1.5,
                });
                gsap.from(".item2 div", {
                    y: '100%',
                    duration: .8,
                    delay: 1.5,
                });
                gsap.from(".desc", {
                    opacity: 0,
                    y: 30,
                    duration: 1,
                    delay: 2.8,
                });
                gsap.from(".greeting__bg", {
                    opacity: 0,
                    duration: 3,
                    delay: 1,
                });

            }
        },
        mounted() {
            if (window.innerWidth >= 1025) {
                this.gsapAbout();
            }
        },
    }

</script>
<style>

</style>